import { render, staticRenderFns } from "./yuzhongstamp.vue?vue&type=template&id=c867b0b2&scoped=true&"
import script from "./yuzhongstamp.vue?vue&type=script&lang=js&"
export * from "./yuzhongstamp.vue?vue&type=script&lang=js&"
import style0 from "./yuzhongstamp.vue?vue&type=style&index=0&id=c867b0b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c867b0b2",
  null
  
)

export default component.exports